import router from '@/router';
import _ from 'lodash';
import AuthRepository from '@/repositories/modules/Auth';
import composableForm from '@/composables/form';

const { catchError } = composableForm();

export default {
	namespaced: true,
	state: () => ({
		status: 'guest',
		user: null,
		token: null
	}),
	getters: {
		token(state) {
			return state.token;
		},
		hasUser(state) {
			return (state.status == 'authenticated');
		},
		verified(state) {
			return state.user?.email_verified;
		},
		user(state) {
			return state.user;
		}
	},
	actions: {
		status({ commit }, status) {
			commit('setStatus', status);
		},
		signup({ commit }, data) {
			return AuthRepository.signup(data).then((response) => {
				commit('setToken', response.data);
			});
		},
		login({ commit }, credentials) {
			return AuthRepository.login(credentials).then((response) => {
				commit('setToken', response.data);
			});
		},
		otp({ commit }, data) {
			return AuthRepository.loginOtp(data).then(response => {
				commit('setToken', response.data);
			});
		},
		loginSocial({ commit }, data) {
			return AuthRepository.loginSocial(data.provider, data.data).then(response => {
				commit('setToken', response.data);
			});
		},
		logout({ commit }) {
			return AuthRepository.logout().finally(() => {
				commit('logout');
				if(router.currentRoute.value.meta.needUser != undefined && router.currentRoute.value.meta.needUser) router.push({ name: 'home' });
			});
		},
		me({ commit }) {
			return AuthRepository.user().then((response) => {
				commit('setUser', response.data);
				commit('setStatus', 'authenticated');
			}).catch((e) => {
				if(e.response.status == 401) router.push({ name: 'auth.logout' });
				catchError(e, true);
			});
		},
		setUser({ commit }, data) {
			commit('setUser', data);
		},
		setToken({ commit }, data) {
			commit('setToken', data);
		}
	},
	mutations: {
		setUser(state, user) {
			state.user = user;
		},
		setToken(state, token) {
			state.token = token;
		},
		loadToken(state, aToken) {
			state.token = aToken;
		},
		loadUser(state, anUser) {
			state.user = anUser;
		},
		setStatus(state, status) {
			state.status = status;
		},
		logout(state) {
			state.status = 'guest';
			state.token = null;
			state.user = null;
		}
	}
};